import { render } from "./PromotionForm.vue?vue&type=template&id=5f8f547e&scoped=true&ts=true"
import script from "./PromotionForm.vue?vue&type=script&lang=ts"
export * from "./PromotionForm.vue?vue&type=script&lang=ts"

import "./PromotionForm.vue?vue&type=style&index=0&id=5f8f547e&scoped=true&lang=css"
import "./PromotionForm.vue?vue&type=style&index=1&id=5f8f547e&lang=css"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8f547e"]])

export default __exports__